<template>
    <div class="main-container">
        <back-tool>
            <el-button size="medium" type="primary" @click="saveHandler()">保存</el-button>
        </back-tool>
        <div class="tree-container" :style="{height: `${windowHeight - 150}px`}">
            <el-tree class="filter-tree"
                     highlight-current
                     :current-node-key="0"
                     ref="tree"
                     :expand-on-click-node='false' show-checkbox
                     :data="treeData"
                     :props="defaultProps"
                     node-key="id"
                     :default-checked-keys="checkedKeys"
                     :default-expanded-keys="defaultExpandedArray"
            >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span :title="data.name">{{ data.name }}</span>
                    </span>
            </el-tree>
        </div>
    </div>

</template>

<script>
    import windowResize from "@/mixins/windowResize.js";

    import {
        queryApiPermTree,
        queryApiListByModuleId,
        insertModuleApiApplication
    } from '@/api/apiPermission';
    import BackTool from '@/components/BackTool';

    export default {
        name: 'moduleAppIntApi',
        components: {BackTool},
        mixins: [windowResize],
        data() {
            return {
                id: this.$route.query.id,
                treeData: [],
                defaultProps: {
                    children: 'childrens',
                    label: 'label'
                },
                checkedKeys: [],

                defaultExpandedArray: [0],
                currentNode: {}
            }
        },
        created() {
            queryApiListByModuleId({
                moduleId: this.id
            })
                .then(data => {
                    if(data && data.length !== 0) {
                        const checkedKeys = [];
                        data.forEach(item => {
                            checkedKeys.push(item.apiPermissionId);
                        });
                        this.checkedKeys = checkedKeys
                    }
                });

            queryApiPermTree({
                module: true
            })
                .then(data => {
                    this.treeData = [data];
                    this.currentNode = data;
                })
        },
        methods: {
            saveHandler() {
                const args = this.$refs.tree.getCheckedNodes(true, false).filter(key => key != 0).map(item => ({
                    apiPermissionId: item.id,
                    apiUrl: item.t,
                    moduleId: this.id
                }));
                insertModuleApiApplication(args)
                    .then(() => {
                        this.$message.success('设置成功');
                        setTimeout(() => {
                            this.$router.back();
                        }, 500);
                    })

            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/permissionSystem/moduleApp/moduleAppIntApi.vue